/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Project { 
    /**
     * Project identifier
     */
    id?: string;
    /**
     * Project Name
     */
    name?: string;
    /**
     * Path of the project
     */
    path?: string;
}

